import React from 'react';
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { TypographyVariant } from '@/type';
import { styled } from '@mui/system';

interface AccordionProps {
  expanded: boolean;
  label: string;
  variant?: TypographyVariant;
  children: React.ReactNode;
}

const Accordion = ({ expanded, label, variant = 'h4', children }: AccordionProps) => {
  const { t } = useTranslation();
  return (
    <CustomAccordion defaultExpanded={expanded}>
      <CustomAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${label}-content`}
        id={`${label}-header`}
      >
        <Typography variant={variant}>{t(label)}</Typography>
      </CustomAccordionSummary>
      <CustomAccordionDetails>
        <Grid container spacing={2}>
          {children}
        </Grid>
      </CustomAccordionDetails>
    </CustomAccordion>
  );
};

const CustomAccordion = styled(MuiAccordion)(() => ({
  boxShadow: 'none',
  border: '1px solid var(--border-color)',
  backgroundColor: 'transparent',
  borderRadius: '10px !important',
  '&.Mui-expanded': {
    margin: '12px 0',
    borderBottom: '1px solid var(--border-color)',
  },
}));

const CustomAccordionSummary = styled(AccordionSummary)(() => ({
  borderBottomRightRadius: '0px !important',
  borderBottomLeftRadius: '0px !important',
  padding: '2x 24px',
}));

const CustomAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '20px 24px',
}));

export default Accordion;
